// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BuildingIcon_wrapper__24Xq-","icon":"BuildingIcon_icon__2i_w1"};